import React from 'react';
import styled from 'styled-components';

const PageContainer = styled.div`
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;
`;

const StyledIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  margin: 0;
  padding: 0;
  display: block;
`;

const CnPage: React.FC = () => {
  return (
    <PageContainer>
      <StyledIframe
        src="https://china.finaconnect.com/cn"
        title="FinaConnect CN"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </PageContainer>
  );
};

export default CnPage;
